import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
  variant?: 'petrol' | 'gold';
}
export function CTAButton({
  children,
  href = '#pricing',
  className = '',
  variant = 'petrol'
}: CTAButtonProps) {
  const isAnchor = href.startsWith('#');
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (!isAnchor) return;
    event.preventDefault();
    document.getElementById(href.substring(1))?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const palette = variant === 'gold' ? 'bg-brand-gold text-brand-navy hover:bg-brand-goldDark border-b-4 border-brand-goldDark shadow-[0_5px_0_rgba(104,74,18,0.3)]' : 'bg-brand-blue text-white hover:bg-brand-blueHover border-b-4 border-brand-navy shadow-[0_5px_0_rgba(36,56,74,0.32)]';
  return <a href={href} onClick={handleClick} target={isAnchor ? undefined : '_blank'} rel={isAnchor ? undefined : 'noopener noreferrer'} className={`block w-full rounded-md px-3 py-3 text-center font-body text-sm font-extrabold uppercase leading-tight tracking-wide transition-transform hover:scale-[1.015] active:translate-y-1 active:border-b-0 sm:text-base ${palette} ${className}`} data-id="element-32" data-mp="3cp2kg5zfcl5f">
      {children}
    </a>;
}